import { useSelector } from "react-redux";
import { State } from "../../../store";
import { useEffect, useState } from "react";
import { GET_TICKET_BY_SHAPE, GET_ALL_ASSORTS } from "../../../api/apiRoutes";
import { get } from "../../../api";
import useFacility from "../../../../utils/hooks/useFacility";
import { Assort } from "../../../models/Assort";

export default function useBasketExtras() {
  const basketExtrasAssortGroupIds = useSelector(
    (state: State) => state.config.configuration.basketExtrasAssortGroupIds,
  );
  const facilityIds = useFacility();
  const [extras, setExtras] = useState<Assort[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getShapeGroupByBasketExtrasAssortIds = async () => {
    setLoading(true);

    // Sprawdzamy czy facilityIds zawiera 1241 lub 1243
    const facilityIdsArray = facilityIds.split(",").map((id) => id.trim());
    const shouldUseNewEndpoint = facilityIdsArray.includes("1241") || facilityIdsArray.includes("1243");

    const url = shouldUseNewEndpoint
      ? GET_ALL_ASSORTS(facilityIds, undefined, basketExtrasAssortGroupIds)
      : GET_TICKET_BY_SHAPE(facilityIds, basketExtrasAssortGroupIds);

    const { result, isError } = await get(url);
    if (!isError && Array.isArray(result)) {
      setExtras(result);
    } else {
      setExtras([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (basketExtrasAssortGroupIds) {
      getShapeGroupByBasketExtrasAssortIds();
    }
    //eslint-disable-next-line
  }, [basketExtrasAssortGroupIds]);

  return {
    extras,
    loading,
  };
}